module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-08.ffc27ff4.png";